import React, { useState } from 'react'
import { Navigate, Link } from 'react-router-dom'
import { doSignInWithEmailAndPassword, doSignInWithGoogle } from './auth'
import { useAuth } from './authContext'

const Login2 = () => {
    const { userLoggedIn } = useAuth()

    const [email, setEmail] = useState('')
    const [password, setPassword] = useState('')
    const [isSigningIn, setIsSigningIn] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const onSubmit = async (e) => {
        e.preventDefault()
        if(!isSigningIn) {
            setIsSigningIn(true)
            await doSignInWithEmailAndPassword(email, password)
            // doSendEmailVerification()
        }
    }

    const onGoogleSignIn = (e) => {
        e.preventDefault()
        if (!isSigningIn) {
            setIsSigningIn(true)
            doSignInWithGoogle().catch(err => {
                setIsSigningIn(false)
            })
        }
    }

    return (
        <div >

Privacy Policy
Effective Date: [02/16/2025]
Last Updated: [02/16/2025]

Welcome to Elevate REI ("we," "our," "us"). Your privacy is important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our mobile application, Elevate REI (the "App"). Please read this policy carefully. If you do not agree with the terms of this policy, please do not use the App.

1. Information We Collect
We may collect the following types of information:

A. Personal Information
We collect personal information that you provide to us when registering an account, such as:

Name
Email address
Phone number
Payment information (if applicable)
B. Automatically Collected Information
When you use the App, we may automatically collect:

Device information (model, OS version, unique device ID)
IP address
Usage data (features used, interactions, session duration)
Location data (if enabled by you)
C. Third-Party Information
We may collect data from third-party services if you integrate them with our App (e.g., lenders, insurance providers, or skip tracing services).

2. How We Use Your Information
We use the collected information for the following purposes:

To provide, maintain, and improve the App
To personalize your user experience
To facilitate property searches, skip tracing, and investment analysis
To process transactions and provide customer support
To send you updates, notifications, or marketing content (with your consent)
To comply with legal obligations
3. Sharing of Information
We do not sell your personal data. However, we may share your information with:

Service Providers: Third parties who help us operate and maintain the App (e.g., payment processors, cloud storage, AI assistants)
Business Partners: Lenders, insurers, or property data providers to facilitate investment decisions
Legal Compliance: When required by law or to protect our rights and security
4. Data Retention
We retain personal data as long as necessary to fulfill the purposes outlined in this policy unless a longer retention period is required by law.

5. Security Measures
We implement appropriate security measures to protect your information from unauthorized access, disclosure, or alteration. However, no method of transmission over the Internet is 100% secure, and we cannot guarantee absolute security.

6. Your Rights & Choices
You have the right to:

Access, update, or delete your personal data
Opt out of marketing emails or notifications
Disable location tracking from your device settings
Request data portability, where applicable
To exercise these rights, contact us at [your contact email].

7. Third-Party Links & Services
Our App may contain links to third-party websites or services. We are not responsible for their privacy practices. Please review their policies before providing personal data.

8. Children's Privacy
Our App is not intended for users under the age of 18. We do not knowingly collect data from minors. If we learn that we have collected such data, we will take steps to delete it.

9. Changes to This Policy
We may update this Privacy Policy periodically. Any changes will be posted within the App, and your continued use constitutes acceptance of the revised policy.

10. Contact Us
If you have any questions about this Privacy Policy, please contact us at:
📧 [jackson@realsync.app]
        </div>
    )
}

export default Login2